module.exports = __webpack_public_path__ + "static/arbershabani-current-80e2c6b7b94775a643868a2e2e64096e.png";